module.exports = __webpack_public_path__ + "static/group-bg-2-9edbd442aabdcedec6858f23fd703deb.jpeg";